<template>
  <div id="F2" class="sub">
    <div class="wrapper">
      <kg-header :headerType=1 />
      <div id="content">
        <div class="inner_static">
          <h1 class="tit1">アンケート</h1>
          <div class="vm_wrap survey_complete_div">
            <div class="inner_static">
              <h2 class="ins_tit type2">アンケートの送信が完了しました。</h2>
              <p class="ins_lead type3">
                アンケートにご協力いただきありがとうございました。<strong>1,000円分のディスカウントクーポン</strong>を差し上げます。ディスカウントクーポンはオーダー時に使用可能となります。
              </p>
            </div>
          </div>
          <div class="fixed_btn_area">
            <div class="inner_static">
              <a class="btn1" @click="btnTopClick()">TOPへ</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

// kaggul Module
import Header from '../components/common/HomeIconHeader'

export default {
  components: {
    'kg-header': Header
  },
  methods: {
    btnTopClick: function () {
      this.$router.push('/kagull/top')
    }
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/SurveyComplete.vue